export enum PositionCreationMode {
  richiestaFido = 'RF',
  utilizzoFido = 'UF'
}
